import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import { tap } from 'rxjs';
import { injectPartnerWebUrl } from '../../providers/partner-web-url.token';
import { isHWS } from '../../providers/platform.token';
import { injectVehicleMarketUrl } from '../../providers/vehicle-market-url.token';
import { getCurrentUrl } from '../../utilities/meta.resolvers';

@Injectable()
export class SeoEffects {
    protected readonly actions$ = inject(Actions);
    protected readonly doc = inject(DOCUMENT);
    protected readonly meta = inject(Meta);
    protected readonly vehicleMarketUrl = injectVehicleMarketUrl();
    protected readonly partnerWebUrl = injectPartnerWebUrl();
    protected readonly isPartnerWeb = isHWS();

    initCanonical = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(ROUTER_NAVIGATED),
                tap(() => {
                    const baseUrl = this.isPartnerWeb ? this.partnerWebUrl : this.vehicleMarketUrl;
                    if (!baseUrl) {
                        return;
                    }
                    const pageUrl = getCurrentUrl(this.doc, baseUrl);
                    const link = this.doc.querySelector("link[rel='canonical']") ?? this.createLink();
                    link.setAttribute('href', pageUrl);
                    this.meta.updateTag({ property: 'og:url', content: pageUrl });
                }),
            );
        },
        { dispatch: false },
    );

    private createLink() {
        const link = this.doc.createElement('link');
        link.setAttribute('rel', 'canonical');
        this.doc.head.appendChild(link);
        return link;
    }
}
